import React, { useState } from "react";
import "./knowbtn.css";
import axios from "axios";
const KnowMoreButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openForm = () => setIsOpen(true);
  const closeForm = () => setIsOpen(false);

  const [activeForm, setActiveForm] = useState("inquiry");
  const [formData, setFormData] = useState({
     name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        type:"knowmore",
        file: null,
  });
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
const handleFormSubmit = (e) => {
  e.preventDefault();

  const whatsappNumber = "919633963361"; // Your WhatsApp number with country code

  const message = `
Hello, I would like to know more.

Name: ${formData.name}
Email: ${formData.email}
Message: ${formData.message}
  `.trim();

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  window.open(whatsappUrl, "_blank");
};

  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setSuccessMsg("");
  //   setErrorMsg("");

  //   try {
  //     const data = new FormData();
  //     for (let key in formData) {
  //       if (formData[key]) data.append(key, formData[key]);
  //     }

  //     // backend
  //     const res = await axios.post("https://thelittleduckling.com/api/contacts", data, {
  //         //  const res = await axios.post("https://duckling-back.vercel.app/api/contacts", data, {
  //     headers: { "Content-Type": "multipart/form-data" },

  //           // const res = await axios.post("http://localhost:5000/api/contacts", data, {
  //     });

  //     setSuccessMsg(res.data.message || "Form submitted successfully!");
  //     setFormData({
  //      name: "",
  //   email: "",
  //   phone: "",
  //   subject: "",
  //   message: "",
  //   type: "knowmore",
  //   file: null,
  //     });
  //   } catch (err) {
  //     console.error(err.response ? err.response.data : err.message);
  //     setErrorMsg("Something went wrong. Try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };




  return (
    <>
      <button className="btn2 btn-lg" onClick={openForm}>
        KNOW MORE
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={closeForm}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-center">Contact Us</h2>
            <form onSubmit={handleFormSubmit}>
              {successMsg && <div className="alert alert-success">{successMsg}</div>}
            {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
              <label>Name</label>
              <input name="name" type="text" placeholder="Your Name" required value={formData.name}
                  onChange={handleChange}/>

              <label>Email</label>
              <input name="email" type="email" placeholder="Your Email" required value={formData.email}
                  onChange={handleChange}/>

              <label>Message</label>
              <textarea name="message" placeholder="Your Message" required value={formData.message}
                  onChange={handleChange}/>

              <button type="submit" onClick={handleFormSubmit}>Submit</button>
              <button type="button" className="close-btn" onClick={closeForm}>
                Close
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default KnowMoreButton;
